module.exports = __webpack_public_path__ + "img/begin_dark_gray.aadc3e76.svg";